import React from 'react'

import { ReactComponent as LoaderSVG } from "../assets/loader.svg";

const Loader = ({ className }: {className?: string}) => {
  return (<LoaderSVG className={className} />)
}

export default Loader;